export const GET_PATIENTS = "GET_PATIENTS";
export const FILTER_PATIENTS = "FILTER_PATIENTS";
export const ADD_PATIENT = "ADD_PATIENT";
export const EDIT_PATIENT = "EDIT_PATIENT";
export const GET_PATIENT = "GET_PATIENT";
export const RESET_PATIENT = "RESET_PATIENT";
export const PATIENTS_ERROR = "PATIENTS_ERROR";
